// extracted by mini-css-extract-plugin
export var actionBtns = "meal-planer-templates-module--action-btns--b68bc";
export var actions = "meal-planer-templates-module--actions--509c0";
export var createOrEdit = "meal-planer-templates-module--createOrEdit--0c638";
export var holder = "meal-planer-templates-module--holder--4a5a6";
export var loader = "meal-planer-templates-module--loader--2a32b";
export var planer = "meal-planer-templates-module--planer--fc3f1";
export var title = "meal-planer-templates-module--title--b43ac";
export var wrapper = "meal-planer-templates-module--wrapper--f5daa";